import SubscriptionApi from '@/api/subscription'

export default {
  namespaced: true,
  state: {
    packages: [],
    packagesFetched: false,
  },
  getters: {
    packagesFetched: (state: any) => state.packagesFetched,
    packages: (state: any) => state.packages ?? [],
  },
  mutations: {
    SET_PACKAGES(state: any, packages: any) {
      state.packages = packages
    },
    SET_PACKAGES_FETCHED(state: any, payload: boolean) {
      state.packagesFetched = payload
    },
  },
  actions: {
    async GET_PACKAGES(context: any) {
      if (context.state.packagesFetched) return
      await SubscriptionApi.packagesList().then((data: any) => {
        context.commit('SET_PACKAGES', data)
        context.commit('SET_PACKAGES_FETCHED', true)
      }).catch(e => {
        throw e
      })
    },
  },
}
